<template>
  <div class="en-date">
    <div
      class="show-content"
      @click="showListPanel"
      :class="{'no-data': !label, 'is-disabled': disabled || fullData.disabled}"
    >
      {{ label ? label : "请选择" }}
    </div>
    <div class="show-list" v-if="showList">
      <div class="title">
        <i class="close-icon el-icon el-icon-close" @click="showList = false"></i>
        {{ fullData.name ? fullData.name : "请选择时间日期" }}
      </div>
      <div class="container">
        <div class="left-list">
          <div
            class="left-item"
            :class="{'active': activeTab === 'year'}"
            @click="changeTab('year')"
          >
            {{ dateInfo.year ? dateInfo.year + "年" : "请选择" }}
          </div>
          <div
            class="left-item"
            v-if="parseInt(fullData.timeFormat) !== 12 && dateInfo.year"
            :class="{'active': activeTab === 'month'}"
            @click="changeTab('month')"
          >
            {{ dateInfo.month ? dateInfo.month + "月" : "请选择" }}
          </div>
          <div
            class="left-item"
            v-if="(parseInt(fullData.timeFormat) === 9 || parseInt(fullData.timeFormat) === 8) && dateInfo.month"
            :class="{'active': activeTab === 'date'}"
            @click="changeTab('date')"
          >
            {{ dateInfo.date ? dateInfo.date + "日" : "请选择" }}
          </div>
          <div
            class="left-item"
            v-if="parseInt(fullData.timeFormat) === 9 && dateInfo.date"
            :class="{'active': activeTab === 'hours'}"
            @click="changeTab('hours')"
          >
            {{ dateInfo.hours ? dateInfo.hours : "请选择" }}
          </div>
          <div
            class="left-item"
            v-if="parseInt(fullData.timeFormat) === 9 && dateInfo.hours"
            :class="{'active': activeTab === 'minutes'}"
            @click="changeTab('minutes')"
          >
            {{ dateInfo.minutes ? dateInfo.minutes : "请选择" }}
          </div>
        </div>
        <div class="right-list">
          <div
            class="right-item"
            v-for="item in list"
            :key="item"
            @click="selectedInfo(item)"
          >
            {{ item }}
            <div
              class="right-item-selected"
              v-if="
               activeTab==='year' ? dateInfo.year === item :
               activeTab === 'month' ? dateInfo.month === item :
               activeTab === 'date' ? dateInfo.date === item :
               activeTab === 'hours' ? dateInfo.hours === item :
               dateInfo.minutes === item
               "
            >
              <i class="el-icon el-icon-check"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    value: {
      default: ""
    },
    fullData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      showList: false,
      activeTab: "year",
      dateInfo: {
        year: null,
        month: null,
        date: null,
        hours: null,
        minutes: null,
        seconds: null
      },
      label: ""
    };
  },
  watch: {
    showList(nVal) {
      if (nVal) {
        document.getElementsByClassName("business-model")[0].style.overflow = 'hidden'
        this.activeTab = "year";
        this.getDateInfo();
        this.getYearList();
      } else {
        document.getElementsByClassName("business-model")[0].style.overflow = 'auto'
      }
    },
    value: {
      deep: true,
      handler(nVal) {
        this.setValue(nVal);
      }
    }
  },
  methods: {
    setValue(nVal) {
      if (parseInt(this.fullData.dateRange, 10) == 0) {
        return
      }
      const format = parseInt(this.fullData.timeFormat, 10)
      let newD = nVal.replace(/-/g, "/")
      const date = new Date(newD)
      if (format === 12) {
        this.label = date.getFullYear()
      } else if (format === 1) {
        this.label = date.getFullYear() + "-" + (date.getMonth() + 1)
      } else if (format === 8) {
        this.label = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      } else {
        this.label = nVal
      }
    },
    getDateInfo() {
      if (this.fullData.value) {
        this.label = this.fullData.value;
        this.dateInfo.year = new Date(this.fullData.value).getFullYear();
        this.dateInfo.month = new Date(this.fullData.value).getMonth() + 1;
        this.dateInfo.date = new Date(this.fullData.value).getDate();
        this.dateInfo.hours = new Date(this.fullData.value).getHours();
        this.dateInfo.minutes = new Date(this.fullData.value).getMinutes();
      } else {
        this.dateInfo = {
          year: null,
          month: null,
          date: null
        };
      }
    },
    /**
     * @description 获取年份列表
     */
    getYearList() {
      this.list = [];
      for (let i = 2099; i > 1900; i--) {
        this.list.push(i > 9 ? i : "0" + i);
      }
      this.scrollToCurrentYear();
    },
    /**
     * @description 获取月份列表
     */
    getMonthList() {
      this.list = [];
      for (let i = 1; i < 13; i++) {
        this.list.push(i > 9 ? i : "0" + i);
      }
    },
    /**
     * @description 获取天数列表
     */
    getDateList() {
      this.list = [];
      let max = new Date(this.dateInfo.year, this.dateInfo.month, 0).getDate();
      for (let i = 1; i <= max; i++) {
        this.list.push(i > 9 ? i : "0" + i);
      }
    },
    /**
     * @description 获取小时列表
     */
    getHoursList() {
      this.list = [];
      for (let i = 0; i < 24; i++) {
        this.list.push(i > 9 ? i : "0" + i);
      }
    },
    /**
     * @description 获取秒数列表
     */
    getSecondsList() {
      this.list = [];
      for (let i = 0; i < 60; i++) {
        this.list.push(i > 9 ? i : "0" + i);
      }
    },
    /**
     * @description 获取分钟列表
     */
    getMinutesList() {
      this.list = [];
      for (let i = 0; i < 60; i++) {
        this.list.push(i > 9 ? i : "0" + i);
      }
    },
    /**
     * @description 选择数据
     * @param res
     */
    selectedInfo(res) {
      // 如果当前的页签是在年份
      if (this.activeTab === "year") {
        // 如果后台的限制只允许选择年份，需要将数据重整成年月日时分秒拼接给后台
        if (parseInt(this.fullData.timeFormat) === 12) {
          this.label = res;
          let dateInfo = res = "-01-01 00:00:00";
          this.$emit("input", dateInfo);
          this.showList = false;
          // 否则继续选择月份信息
        } else {
          this.activeTab = "month";
          this.dateInfo.year = res;
          this.getMonthList();
        }
        // 如果当前的页签是在月份
      } else if (this.activeTab === "month") {
        // 如果后台的限制只允许选择到月份，需要将数据重整成年月日时分秒拼接给后台
        if (parseInt(this.fullData.timeFormat) === 1) {
          this.label = this.dateInfo.year + "-" + res;
          let dateInfo = this.dateInfo.year + "-" + res + "-01-01 00:00:00";
          this.$emit("input", dateInfo);
          this.showList = false;
          // 否则继续选择天数信息
        } else {
          this.activeTab = "date";
          this.dateInfo.month = res;
          this.getDateList();
        }
        // 如果当前的页签是天数
      } else if (this.activeTab === "date") {
        // 如果后台的限制只允许选择到天数，需要将数据重整成年月日时分秒拼接给后台
        if (parseInt(this.fullData.timeFormat) === 8) {
          this.label = this.dateInfo.year + "-" + this.dateInfo.month + "-" + res;
          let dateInfo = this.dateInfo.year + "-" + this.dateInfo.month + "-" + res + " 00:00:00";
          this.$emit("input", dateInfo);
          this.showList = false;
        } else {
          this.activeTab = "hours";
          this.dateInfo.date = res;
          this.getHoursList();
        }
        // 如果当前的页签是小时，需要继续选择分钟信息
      } else if (this.activeTab === "hours") {
        this.activeTab = "minutes";
        this.dateInfo.hours = res;
        this.getMinutesList();
        // 如果当前的页签是分钟，选择完即处理数据
      } else if (this.activeTab === "minutes") {
        let dateInfo = this.dateInfo.year + "-" + this.dateInfo.month
          + "-" + this.dateInfo.date + " " + this.dateInfo.hours + ":" + res + ":00";
        this.label = this.dateInfo.year + "-" + this.dateInfo.month
          + "-" + this.dateInfo.date + " " + this.dateInfo.hours + ":" + res;
        this.$emit("input", dateInfo);
        this.$emit("change", this.fullData);
        this.showList = false;
      }
    },
    /**
     * @description 显示选择面板
     */
    showListPanel() {
      this.showList = !this.disabled && !this.fullData.disabled;
    },
    /***
     * @description 页签切换
     * @param type
     */
    changeTab(type) {
      this.activeTab = type;
      if (type === "year") {
        this.getYearList();
        this.dateInfo = {
          year: null,
          month: null,
          date: null,
          hours: null,
          minutes: null
        }
      } else if (type === "month") {
        this.getMonthList();
        this.dateInfo.month = null
        this.dateInfo.date = null
        this.dateInfo.hours = null
        this.dateInfo.minutes = null
      } else if (type === "date") {
        this.getDateList();
        this.dateInfo.date = null
        this.dateInfo.hours = null
        this.dateInfo.minutes = null
      } else if (type === "hours") {
        this.getHoursList();
        this.dateInfo.hours = null
        this.dateInfo.minutes = null
      } else if (type === "minutes") {
        this.getMinutesList();
        this.dateInfo.minutes = null
      } else {
        this.getSecondsList();
      }
    },
    /**
     * @description 年份信息需要滚动到当前的年份
     */
    scrollToCurrentYear() {
      let diff = 0;
      // 如果选择的信息内有年份，直接滚动到信息的年份
      if (this.dateInfo.year) {
        diff = 2099 - this.dateInfo.year;
        // 否则滚动到当前的年份
      } else {
        diff = 2099 - new Date().getFullYear();
      }
      setTimeout(() => {
        document.getElementsByClassName("right-list")[0].scrollTop = diff * 50;
      }, 200);
    }
  },
  mounted() {
    this.fullData._setValue = (val) => {
      this.setValue(val)
    }
    if (this.fullData.value) {
      this.setValue(this.fullData.value)
    }
    if (this.fullData.mdValue && this.fullData.mdValue.length > 0) {
      this.setValue(this.fullData.mdValue)
    }
  }
};
</script>

<style lang="scss" scoped>
  .en-date {
    width: 100%;

    .is-disabled {
      background-color: #f9f9f9;
    }

    .show-content {
      text-align: right;
    }

    .show-list {
      position: fixed;
      z-index: 8;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      .title {
        text-align: center;
        color: #ffffff;
        position: relative;
        width: 100%;
        height: 50px;
        line-height: 50px;
        background-color: #31415A;

        .close-icon {
          position: absolute;
          font-size: 32px;
          top: 9px;
          left: 9px;
        }
      }

      .container {
        display: flex;
        justify-content: flex-start;
        height: calc(100% - 50px);
        overflow: auto;

        .left-list {
          width: 32%;
          background-color: #E8E8E8;
          height: 100%;

          .left-item {
            line-height: 50px;
            color: #848484;
            padding-left: 20px;

            &.active {
              background-color: #ffffff;
              color: #333333;
            }
          }
        }

        .right-list {
          width: 68%;
          height: 100%;
          overflow: auto;
          padding-left: 3%;
          background-color: #ffffff;

          .right-item {
            border-bottom: 1px solid #E8E8E8;
            line-height: 50px;
            text-align: left;
            position: relative;

            &:nth-last-child(1) {
              border-bottom: none;
            }

            .right-item-selected {
              position: absolute;
              right: 20px;
              top: 0;
              color: #677EA3;
            }
          }
        }
      }

    }
  }
</style>
